import React, { useEffect, useState } from 'react';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import useTheme from '@material-ui/styles/useTheme';
import makeStyles from "@material-ui/styles/makeStyles";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { MaterialTable } from '../../components';
import api from '../../common/api';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

const useStyles = makeStyles(theme => ({
    root: props => ({
        margin: props.isDesktop ? theme.spacing(4) : theme.spacing(1)
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
}));

const AvailableFeed = ({ showError, showMessage, match }) => {
    const theme = useTheme();
    const farmID = match.params['farmID'];
    const [loading, setLoading] = useState(false);
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({ isDesktop });
    const [feedStockList, setFeedStockList] = useState(null);

    const getAllFeedStockList = () => {
        showError('');
        showMessage('');

        const response = api.post(`/feed-stock/get-feed-list/${farmID}`, {});
        response.then(res => {
            setFeedStockList(res);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No Feed List');
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        });

        return response;
    }

    const onload = () => {
        setLoading(true);
        Promise.all([getAllFeedStockList()]).finally(() => {
            setLoading(false);
        });
    }
    useEffect(onload, []);

    // PDF Export
    const handleExportPDF = (data, title) => {
        try {
            const doc = new jsPDF();
            const header = ['Name', 'Available Quantity (kg)', 'Average Cost per kg'];
            const rows = data.map(row => [
                row.materialName,
                row.availableStock?.toFixed(2),
                row?.averageCost?.toFixed(2) || '',
            ]);

            doc.text(title, 14, 15);
            doc.autoTable({
                head: [header],
                body: rows,
                startY: 20,
                theme: 'grid',
                styles: { fontSize: 10, halign: 'center', cellPadding: 3 },
                headStyles: { fillColor: [60, 66, 77], textColor: 255, fontStyle: 'bold', halign: 'center' },
                bodyStyles: { textColor: 50 },
            });

            doc.save(`${title}.pdf`);
        } catch (err) {
            console.error("PDF Export Failed:", err);
        }
    };

    const handleExportCSV = (data, fileName) => {
        const header = ['Name', 'Available Quantity (kg)', 'Average Cost per kg'];
        const rows = data.map(row => [
            row.materialName,
            row.availableStock?.toFixed(2),
            row?.averageCost?.toFixed(2) || '',
        ]);

        const csvContent = [header, ...rows].map(e => e.join(',')).join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const feedData = feedStockList !== null && feedStockList !== undefined &&
        Array.isArray(feedStockList["Feed"]) && feedStockList["Feed"].length > 0
        ? feedStockList["Feed"] : [];

    return <div className={classes.root}>
        <Grid
            container
            justify='space-between'
            alignItems='flex-end'
            className={classes.topBar}
        >
            <Grid>
                <Typography display="block" variant="h3" gutterBottom>
                    Available Feed
                </Typography>
            </Grid>
        </Grid>
        <MaterialTable
            isLoading={loading}
            columns={[
                { title: 'Name', field: 'materialName', editable: 'never' },
                { title: 'Available Quantity (kg)', field: 'availableStock', editable: 'never', render: rd => rd.availableStock.toFixed(2) },
                { title: 'Average Cost per kg', field: 'averageCost', editable: 'never', render: rd => rd?.averageCost?.toFixed(2) || "" },
            ]}
            data={feedData}
            title='Feed'
            options={{
                actionsColumnIndex: -1,
                search: true,
                showTitle: true,
                toolbar: true
            }}
            actions={[
                {
                    icon: 'save_alt',
                    tooltip: 'Export to Excel',
                    isFreeAction: true,
                    onClick: () => { handleExportCSV(feedData, 'Feed'); },
                },
                {
                    icon: () => <PictureAsPdfIcon />,
                    tooltip: 'Export to Pdf',
                    isFreeAction: true,
                    onClick: () => { handleExportPDF(feedData, `Feed (${window.localStorage.getItem("farmName")})`); },
                }
            ]}
        />
    </div>
}

export default AvailableFeed;
